import './assets/css/App.css';
import { Routes, Route } from 'react-router-dom';
import {} from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import { UserProvider } from './contexts/UserContext';
import {
  ChakraProvider,
  // extendTheme
} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import { useState } from 'react';
// Chakra imports

import { Toaster } from 'react-hot-toast';
import GuestRoute from 'components/GuestRoute';
import ProtectedRoute from 'components/ProtectedRoute';
import Home from 'pages/Home';

export default function Main() {
  // eslint-disable-next-line
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  return (
    <ChakraProvider theme={currentTheme}>
      <UserProvider>
        <Toaster
  position="top-center"
  gutter={6}
  containerStyle={{
    top: 16,
  }}
  toastOptions={{
    duration: 2600,
    style: {
      background: "rgba(20,20,20,0.9)",
      color: "#e5e5e5",
      borderRadius: "12px",
      padding: "10px 16px",
      fontSize: "13px",
      border: "1px solid rgba(255,255,255,0.08)",
      backdropFilter: "blur(10px)",
      boxShadow: "0 8px 30px rgba(0,0,0,0.5)",
      textAlign: "center",
      fontWeight: "500",
      minWidth: "220px",
    },

    success: {
      iconTheme: {
        primary: "#22c55e",
        secondary: "#141414",
      },
    },

    error: {
      iconTheme: {
        primary: "#ef4444",
        secondary: "#141414",
      },
    },

    loading: {
      iconTheme: {
        primary: "#3f9eff",
        secondary: "#141414",
      },
    },
  }}
/>
        <Routes>
          <Route path="auth/*" element={
            <GuestRoute>
              <AuthLayout />
            </GuestRoute>
            }
            />
        <Route path="/" element={<Home />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
            </ProtectedRoute>
          }
        />
        </Routes>
      </UserProvider>
    </ChakraProvider>
  );
}
